import React from 'react';
import { motion } from 'framer-motion';
import { Home, HardHat } from 'lucide-react';
import { Button } from './ui/Button';
export function WhoWeServeSection() {
  return <section className="py-24 bg-white" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="text-center mb-16" data-id="element-185">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-sunrise-charcoal mb-4" data-id="element-186">
            Who We Serve
          </h2>
          <p className="text-lg text-gray-600" data-id="element-187">
            Dedicated service for both residential and commercial needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-188">
          {/* Homeowners Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden rounded-2xl bg-sunrise-cream p-10 border-2 border-transparent hover:border-sunrise-orange/20 transition-all duration-300" data-id="element-189">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-sunrise-orange/10 rounded-full blur-xl group-hover:bg-sunrise-orange/20 transition-colors" data-id="element-190" />

            <Home className="w-12 h-12 text-sunrise-orange mb-6" data-id="element-191" />
            <h3 className="font-heading text-3xl font-bold text-sunrise-charcoal mb-4" data-id="element-192">
              Homeowners
            </h3>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-193">
              Planning a remodel or custom build? We bring your vision to life
              with expert finish carpentry that adds value and beauty to your
              home.
            </p>
            <Button variant="primary" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-194">
              Get Your Free Estimate
            </Button>
          </motion.div>

          {/* Contractors Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative overflow-hidden rounded-2xl bg-sunrise-charcoal p-10 text-white" data-id="element-195">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-xl group-hover:bg-white/20 transition-colors" data-id="element-196" />

            <HardHat className="w-12 h-12 text-sunrise-gold mb-6" data-id="element-197" />
            <h3 className="font-heading text-3xl font-bold text-white mb-4" data-id="element-198">
              General Contractors
            </h3>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed" data-id="element-199">
              Need a reliable finish carpentry sub? We show up on time, on
              budget, and deliver quality every time. Let's build a partnership.
            </p>
            <Button className="bg-white text-sunrise-charcoal hover:bg-gray-100" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-200">
              Partner With Us
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}